import { motion } from "framer-motion"
// import Topnav from "../../../components/topnav/topnav"

const IframeEditorializado = () => {
  return (
    <section className="w-full h-full overflow-hidden rounded-2xl relative">
      {/* Topnav opcional */}
      {/* <Topnav /> */}

      <div className="w-full h-full">
        <motion.div
          className="w-full h-full overflow-hidden rounded-2xl"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            duration: 1.5,
            ease: "easeInOut",
          }}
        >
          <iframe
            src="./frames/editorializado/index.html"
            title="Contenido Editorializado"
            className="w-full h-full border-0 overflow-hidden"
          />
        </motion.div>
      </div>
    </section>
  )
}

export default IframeEditorializado